const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgNWEyIDIgMCAwIDEgMiAydjE1LjYxOGwtNy0zLjUtNyAzLjVWN2EyIDIgMCAwIDEgMi0yaDEwem0wIDJINXYxMi4zODJsNS0yLjUgNSAyLjVWN3ptNC02YzEuMTA1IDAgMiAuOTEgMiAyLjAzNHYxNS44OThsLTItMS4wMTZWM0g4Yy4wMTgtMS4xMDguOTA3LTIgMi0yaDl6IiAgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export {
  M as default
};
//# sourceMappingURL=bookmarks-23ac3b6f.mjs.map
